export const GET_ICONS = "GET_ICONS";
export const GET_STATE_LOADING_ICONS = "GET_STATE_LOADING_ICONS";